(() => {
  window.swapwearPanelSetSelector = function(options = {}) {
    return {
      revision: 0,
      now: Date.now(),
      interval: null,
      giftData: {},
      init() {
        try { this.giftData = JSON.parse(this.$el?.querySelector?.('[data-panel-set-gifts]')?.textContent || '{}') || {}; } catch (_) { this.giftData = {}; }
        this.interval = setInterval(() => {
          const next = Date.now();
          if (this.active(next) !== this.active()) this.now = next;
        }, 1000);
      },
      destroy() { clearInterval(this.interval); },
      cartData() { return options.readCart?.() || {}; },
      profile() { return options.readProfile?.() || {}; },
      state() {
        void this.revision;
        return window.swapwearPanelSet?.snapshot(this.cartData()) || {goal:null,count:0,complete:false};
      },
      active(at = this.now) {
        const p = this.profile();
        const start = new Date(p.start || '').getTime();
        const end = new Date(p.end || '').getTime();
        return p.active === true && Number(p.id) > 0 && String(p.type || 'none') !== 'none' && Number.isFinite(start) && Number.isFinite(end) && at >= start && at < end;
      },
      headline() {
        const p = this.profile();
        return this.active() ? String(p.messaging?.headline || p.eventLabel || p.title || '') : '';
      },
      number(value) { const n = Number(value); return Number.isFinite(n) ? n : 0; },
      discount(count) {
        if (!this.active()) return 0;
        const p = this.profile(), offer = p.offer || {};
        if (p.type === 'sitewide') {
          if (offer.application_method === 'code' || offer.discount_type === 'fixed' || Number(offer.minimum_spend || 0) > 0 || (offer.target && offer.target !== 'all')) return 0;
          const amount = this.number(p.discount ?? offer.percentage_off);
          return amount > 0 && amount <= 100 ? amount : 0;
        }
        let tiers = [];
        if (p.type === 'tier' && ['panel_only','panel_and_base'].includes(p.tierMode || offer.tier_mode)) {
          tiers = (Array.isArray(offer.tiers) ? offer.tiers : p.tiers || []).filter(t => !t.synthetic && (!Number(t.req_jackets || 0) || Number(this.cartData().total_bases || 0) >= Number(t.req_jackets)));
        } else if (p.type === 'panel_base_tier') {
          tiers = offer.panel_discount_tiers || [];
        }
        return tiers.reduce((best, tier) => {
          const threshold = this.number(tier.threshold ?? tier.req_art ?? tier.panel_quantity);
          const discount = this.number(tier.percentage_off ?? tier.discount);
          return Number.isInteger(threshold) && threshold > 0 && count >= threshold && discount > 0 && discount <= 100 ? Math.max(best, discount) : best;
        }, 0);
      },
      freeFirstSwap() {
        const offer = window.__initialData?.firstSwapOffer;
        return offer?.enabled === true && /^[A-Z0-9_-]{3,64}$/.test(String(offer.code || '').trim().toUpperCase()) &&
          Array.isArray(offer.baseHandles) && offer.baseHandles.length > 0;
      },
      displayChoices() { return [1, 3, 5]; },
      giftText(key, values = {}) {
        return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', String(value)), String(this.giftData.copy?.[key] || ''));
      },
      giftRewards() {
        const rewards = [];
        const cart = this.cartData();
        const first = window.swapwearPanelSet?.firstSwapState?.(cart) || {};
        const pending = this.progressPending();
        if (this.freeFirstSwap()) rewards.push({ id: 'first-swap', image: '', title: this.giftText('gift_first_panel'),
          detail: this.giftText('gift_first_requirement'), unlocked: !pending && first.eligible === true,
          applied: !pending && first.applied === true });
        const offer = this.profile().offer?.mystery_panel;
        const mystery = window.__initialData?.mystery_data?.[2];
        const threshold = Number(offer?.threshold_panel_quantity);
        const value = mystery?.rewardVariantId;
        const reward = String(value?.id || value?.value || value || '').match(/^(?:gid:\/\/shopify\/ProductVariant\/)?([1-9]\d*)$/)?.[1];
        const product = this.giftData.product || {};
        const configured = product.available === true && Array.isArray(product.variantIds) && product.variantIds.some(id => String(id) === reward);
        if (this.active() && offer?.enabled === true && Number(offer.discount_percentage) === 100 && mystery?.active === true &&
          Number.isInteger(threshold) && threshold > 0 && Number(mystery.req) === threshold && reward && configured) {
          const unlocked = !pending && this.progressCount() >= threshold;
          const applied = unlocked && (cart.items || []).some(item => String(item.variant_id || item.id) === reward && Number(item.quantity) > 0 && Number(item.original_line_price) > 0 && Number(item.final_line_price) === 0);
          const retailValue = typeof product.retailValue === 'number' || typeof product.retailValue === 'string' && product.retailValue.trim() ? Number(product.retailValue) : 0;
          rewards.push({ id: 'mystery-panel', image: product.image || '', title: this.giftText('gift_mystery_panel'),
            detail: this.giftText('gift_mystery_requirement', { count: threshold }), unlocked, applied,
            retailValue: Number.isFinite(retailValue) && retailValue > 0 ? Math.round(retailValue) : 0 });
        }
        return rewards;
      },
      giftStatus(gift) { return gift.applied ? this.giftText('gift_included') : gift.unlocked ? this.copy('free') : this.giftText('gift_locked'); },
      label(count) {
        if (count === 1 && this.freeFirstSwap()) return this.copy('free');
        const discount = this.discount(count);
        if (discount > 0) return this.copy('percent_off').replace('__PERCENT__', discount);
        return '';
      },
      purchasePhrase(summary) {
        return String(summary || '').match(/^(.+?\s\d+\sSwaps?)(?=[,\s]|$)/u)?.[1] || '';
      },
      summaryAfterPurchase(summary) {
        return String(summary || '').slice(this.purchasePhrase(summary).length);
      },
      offerSummary() {
        if (!(this.discount(this.offerCount()) > 0)) return '';
        return this.goalSummary();
      },
      offerCount() {
        const count = this.progressCount();
        const current = this.discount(count);
        const choices = [1, 2, 3, 4, 5];
        if (current > 0) return choices.find(value => this.discount(value) === current) || Math.min(5, Math.max(1, count));
        return choices.find(value => this.discount(value) > 0) || this.progressGoal();
      },
      goalSummary() {
        const count = this.offerCount();
        const rate = this.discount(count);
        if (!(rate > 0)) return this.copy(count === 1 ? 'goal_bundle_one' : 'goal_bundle_many').replace('__COUNT__', count);
        const p = this.profile();
        const order = p.type === 'sitewide' || (p.type === 'tier' && (p.tierMode || p.offer?.tier_mode) === 'panel_and_base');
        if (p.type === 'sitewide') return this.copy(order ? 'offer_order_single' : 'offer_panels_single').replace('__PERCENT__', rate);
        const key = count === 1 ? (order ? 'goal_order_one' : 'goal_panels_one') : (order ? 'offer_order' : 'offer_panels');
        return this.copy(key).replace('__COUNT__', count).replace('__PERCENT__', rate);
      },
      goalApplied() {
        if (!this.active()) return false;
        const p = this.profile(), cart = this.cartData();
        if (p.type === 'sitewide' && p.offer?.code) {
          const confirmed = window.swapwearPromo?.confirmation?.(cart, p.offer.code)?.applied === true;
          if (p.offer.application_method === 'code' || confirmed) return confirmed;
        }
        const rate = this.discount(this.offerCount());
        if (!(rate > 0 && this.discount(this.state().count) >= rate)) return false;
        return window.swapwearPanelSet?.savingsApplied?.(cart, rate, p) === true;
      },
      copy(key) { return window.__initialData?.panelSetCopy?.[key] || ''; },
      applied() {
        const cart = this.cartData();
        return Number(cart.total_discount || 0) > 0 || (cart.items || []).some(item => Number(item.original_line_price || 0) > Number(item.final_line_price ?? item.original_line_price ?? 0) || (item.line_level_discount_allocations || item.discount_allocations || []).some(a => Number(a.amount || 0) > 0));
      },
      offerApplied() {
        return Boolean(this.offerSummary()) && this.goalApplied();
      },
      progressGoal() { return Math.max(1, Math.min(5, Number(this.state().goal) || 3)); },
      progressCount() { return Math.max(0, Number(this.state().count) || 0); },
      milestoneReached(count) { return this.progressCount() >= count; },
      milestoneLabel(count) {
        return [count, this.copy(count === 1 ? 'choice_unit_one' : 'choice_unit_many'), count === 1 && this.freeFirstSwap() ? this.copy('first_swap_with_base') : this.label(count), this.milestoneReached(count) ? this.copy('milestone_reached') : ''].filter(Boolean).join(' ');
      },
      milestoneProgress() { return this.copy('progress').replace('__COUNT__', Math.min(5, this.progressCount())).replace('__GOAL__', 5); },
      progressPending() { return options.readPending?.() === true; },
      progressComplete() { return !this.progressPending() && this.state().complete === true; },
      progressPercent() { return Math.min(100, this.progressCount() / this.progressGoal() * 100); },
      progressLabel() {
        if (this.progressPending()) return this.copy('dialog_busy');
        if (this.progressComplete()) return this.copy('cart_complete');
        return this.copy('progress').replace('__COUNT__', this.progressCount()).replace('__GOAL__', this.progressGoal());
      },
      cartSavingsLabel() {
        if (!this.active() || this.progressPending()) return '';
        const p = this.profile(), cart = this.cartData();
        if (p.type === 'sitewide' && p.offer?.application_method === 'code') {
          return window.swapwearPromo?.confirmation?.(cart, p.offer.code)?.applied === true ? this.copy('applied') : '';
        }
        const savings = window.swapwearPanelSet?.savings?.(cart, p);
        if (!savings?.applied) return '';
        return savings.maximum ? this.copy('maximum_toast') : this.copy('percentage_applied').replace('__PERCENT__', savings.discount);
      },
      progressDescription() {
        return [this.progressLabel(), this.cartSavingsLabel()].filter(Boolean).map(text => String(text).replace(/[.!]+$/u, '')).join('. ');
      },
      progressActionLabel() { return [this.copy('change'), this.progressDescription()].filter(Boolean).join('. '); },
      changeBundle() {
        window.dispatchEvent(new window.CustomEvent('swapwear:panel-set-options'));
      },
      choose(count) {
        if (!Number.isInteger(count) || count < 1 || count > 5 || (!this.active() && !this.freeFirstSwap())) return false;
        const engine = window.swapwearPanelSet;
        if (engine?.activatePromotion?.(this.cartData(), { threshold: count, pending: this.progressPending() }) !== true) return false;
        this.revision++;
        return true;
      },
      update() {
        this.revision++;
      }
    };
  };
})();
